import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../common/components/base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TicketType } from '../../../common/types/ticket-type';
import { PopupService } from '../../../common/services/popup.service';
import { LoaderService } from '../../../common/services/loader.service';
import { ReceivedTicket } from '../../../common/types/user';
import { TicketsService } from '../../../common/services/tickets.service';
import { TicketStatus } from '../../../common/enum/ticket-status';
import { StorageService } from '../../../common/services/storage.service';

@Component({
  selector: 'app-received-ticket-page',
  templateUrl: './received-ticket-page.component.html',
  styleUrls: ['./received-ticket-page.component.scss'],
})
export class ReceivedTicketPageComponent
  extends BaseComponent
  implements OnInit
{
  constructor(
    private router: Router,
    private ticketService: TicketsService,
    private popupService: PopupService,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private storageService: StorageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.loaderService.show();
    const ticketId = this.activatedRoute.snapshot.paramMap.get('ticketId');
    if (!ticketId) {
      this.loaderService.hide();
    }
    let receivedTicket: ReceivedTicket;
    this.ticketService
      .getUserReceivedTicketById(ticketId)
      .pipe(
        switchMap((ticket: ReceivedTicket) => {
          this.loaderService.hide();
          receivedTicket = ticket;
          return this.popupService.showReceivedTicketPopup(ticket, true)
            .action$;
        }),
        switchMap((status: TicketStatus) => {
          this.storageService.removeFromStorage('ticketId');
          if (!status) {
            return of(null);
          }
          return this.popupService.showReceivedAcceptOrDeclinePopup(
            receivedTicket.source.firstName,
            receivedTicket.source.lastName,
            status
          ).action$;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => this.navigateToReservationsPage());
  }

  private navigateToReservationsPage(): void {
    this.router.navigate([`/my/season-tickets/reservations`], {
      queryParams: { filterType: TicketType.received },
    });
  }
}
